export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-search-eye-line',
      title: 'Поиск товаров',
      desc: 'Быстрый поиск по тысячам товаров из Китая с фильтрацией по категориям и поставщикам.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Сравнение цен',
      desc: 'Сравнивайте цены на один товар у разных поставщиков в одной таблице.',
    },
    {
      icon: 'ri-user-star-line',
      title: 'Анализ поставщиков',
      desc: 'Оценивайте надёжность поставщиков на основе рейтингов и истории заказов.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Контроль доставки',
      desc: 'Отслеживайте статус доставки и выбирайте оптимальные способы отправки.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Минимизация рисков',
      desc: 'Проверенные поставщики и система возврата снижают риски при закупках.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Инструменты прибыли',
      desc: 'Калькулятор маржи и аналитика помогают максимизировать прибыль с каждой сделки.',
    },
  ];

  return (
    <section id="features" className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <span className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.2em]">Возможности</span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mt-3 leading-tight">
              Почему YOYBUY<br />Spreadsheet?
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
            YOYBUY Spreadsheet — это не просто таблица. Это целая система управления
            закупками из Китая, созданная для экономии вашего времени и денег.
          </p>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={feature.title}
              className={`group rounded-2xl p-6 md:p-7 flex flex-col gap-4 transition-all duration-300 cursor-default ${
                idx === 0
                  ? 'bg-foreground-900 lg:row-span-2'
                  : 'bg-background-100 hover:bg-background-200/70'
              }`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl transition-colors ${
                idx === 0
                  ? 'bg-primary-500/20'
                  : 'bg-background-200 group-hover:bg-background-300'
              }`}>
                <i className={`${feature.icon} text-xl ${
                  idx === 0 ? 'text-primary-400' : 'text-foreground-600'
                }`}></i>
              </div>
              <h3 className={`text-lg font-heading font-bold ${
                idx === 0 ? 'text-background-50' : 'text-foreground-900'
              }`}>
                {feature.title}
              </h3>
              <p className={`text-sm leading-relaxed ${
                idx === 0 ? 'text-foreground-300' : 'text-foreground-500'
              }`}>
                {feature.desc}
              </p>

              {idx === 0 && (
                <div className="mt-auto pt-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20laptop%20screen%20showing%20clean%20organized%20spreadsheet%20with%20product%20data%20columns%20and%20analytics%20on%20minimal%20warm%20toned%20desk%20natural%20morning%20light%20from%20side%20soft%20shadows%20professional%20yet%20approachable%20workspace%20aesthetic%20editorial%20photography%20style&width=600&height=400&seq=feature-v2-spreadsheet-2026&orientation=landscape"
                    alt="YOYBUY Spreadsheet interface"
                    className="w-full rounded-xl object-cover h-48"
                    loading="lazy"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}